//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export enum RightsRequestOptions {
  COMMENTS = 'comments',
  DM = 'dm',
}
